import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import loadGames from './loadGames.gql'
import loadable from '@loadable/component'

const GameCarousel = loadable(() => import('@albatross/common-components/dist/components/GameCarousel'))

const GameCarouselContainer = (props) => {
  const { data, venture, enableContentful } = props
  if (data.loading) {
    return null
  }
  if (!data.loading && data.error) {
    return data.error
  }
  const games = data.games ?? data.contentfulGames ?? []
  return (
    <GameCarousel games={games} venture={venture} enableContentful={enableContentful} />
  )
}

export default graphql(loadGames, {
  options: props => {
    return {
      variables: {
        gameIds: props.query?.gameIds,
        published: true,
        released: true,
        categoryId: props.query?.categoryId,
        tags: props.query?.tags,
        sort: props.query?.sort,
        sortOrder: props.query?.sortOrder,
        limit: props.query?.limit,
        enableContentful: props?.enableContentful ?? false
      }
    }
  }
})(GameCarouselContainer)

GameCarouselContainer.propTypes = {
  data: PropTypes.object.isRequired,
  venture: PropTypes.string,
  enableContentful: PropTypes.bool
}
